export class OrderingAvailabilityService {
    constructor(params) {
        this.rpcService = params.rpcService;
    }
    async getOrderingAvailability(restaurantId) {
        return await this.rpcService.rpc("GetOrderingAvailabilityRequest", {
            restaurantId: restaurantId.value,
            isQrWaiterOrder: false,
        });
    }
}
